import { render, staticRenderFns } from "./CircleAssignRole.vue?vue&type=template&id=4ec61a90&scoped=true"
import script from "./CircleAssignRole.vue?vue&type=script&lang=js"
export * from "./CircleAssignRole.vue?vue&type=script&lang=js"
import style0 from "./CircleAssignRole.vue?vue&type=style&index=0&id=4ec61a90&prod&scoped=true&lang=scss"
import style1 from "./CircleAssignRole.vue?vue&type=style&index=1&id=4ec61a90&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec61a90",
  null
  
)

export default component.exports